<app-modal title="{{ weekExists() ? 'Edit' : 'Add' }} Store Closure" #modalComponent>
  <form (ngSubmit)="onSubmit()" #f="ngForm" class="p-3" autocomplete="off">

    <app-input-date
            [isDisabled]="weekExists()"
            [placeholder]="'Date'"
            [name]="'date'"
            [inputDate]="selectedDate()"
            (inputDateChange)="selectedDate.set($event)"
            [editDate]="editDate()"
            [onlyMondays]="false">
    </app-input-date>

    <div class="mb-3 mt-2">
      <label for="reason">Reason</label>
      <input class="form-control"
             type="text"
             id="reason"
             name="reason"
             [ngModel]="selectedReason()"
             (ngModelChange)="selectedReason.set($event)"
             required
             #reason="ngModel">
      @if (reason.errors && reason.touched) {
        <div class="form-error-message">
          @if (reason.errors.required) {
            <p>Reason is required</p>
          }
        </div>
      }
    </div>

    <div class="mt-4 text-end">
      <button class="btn btn-primary-outline btn-form me-3 close-button" type="button"
              (click)="modalComponent.activeModal.close()">Close
      </button>
      <button
              class="btn btn-primary btn-form save-button"
              type="submit"
              [disabled]="!f.valid || !selectedDate() || loading()">Save
      </button>
    </div>
  </form>
</app-modal>